export const getDollarByPrice = (
    price: number,
    currency?:
        | 'USD'
        | 'KRW'
        | 'EUR'
        | 'AUD'
        | 'BRL'
        | 'CAD'
        | 'CNY'
        | 'GBP'
        | 'HKD'
        | 'IDR'
        | 'JPY'
        | 'MYR'
        | 'NZD'
        | 'PHP'
        | 'SGD'
        | 'TWD'
        | 'THB'
        | 'VND'
        | undefined
): number => {
    const rates: Record<NonNullable<typeof currency>, number> = {
        USD: 1,
        KRW: 0.00073,
        EUR: 1.08,
        AUD: 0.66,
        BRL: 0.2,
        CAD: 0.73,
        CNY: 0.14,
        GBP: 1.25,
        HKD: 0.13,
        IDR: 0.000063,
        JPY: 0.0065,
        MYR: 0.21,
        NZD: 0.61,
        PHP: 0.017,
        SGD: 0.74,
        TWD: 0.031,
        THB: 0.027,
        VND: 0.000039,
    };

    const rate = currency ? rates[currency] ?? 1 : 1;

    return Number((price * rate).toFixed(3));
};
